// @ts-nocheck
import { chain, PopulateApiParameter } from "@insite/client-framework/Store/Data/Carts/Handlers/LoadCurrentCart";
import { getCurrentPage } from "@insite/client-framework/Store/Data/Pages/PageSelectors";
import { CustomLoadCurrentCartParameter } from "@store/Framework/Types/types";
import { replaceInChain } from "@toolkit/Modules/client-framework/HandlerCreator";

replaceInChain(chain, PopulateApiParameter, props => {
    PopulateApiParameter(props);
    const pageType = getCurrentPage(props.getState()).type;
    if ((props.parameter as CustomLoadCurrentCartParameter).invalidateCall) {
        props.apiParameter.additionalQueryStringParameters = {
            ...props.apiParameter.additionalQueryStringParameters,
            timestamp: Date.now(),
        };
    }
    if (pageType === "CheckoutReviewAndSubmitPage" || pageType === "OnePageCheckoutPage") {
        props.apiParameter.additionalQueryStringParameters = {
            ...props.apiParameter.additionalQueryStringParameters,
            DefaultPoNumber: true,
        };
    }
});
